import { HttpBadStatusCodeError, TPrimitives } from '@cian/peperrors/shared';
import type { FetchResponse } from '@cian/http-api';

import {
  fetchConsultationRequest,
  TConsultationRequestRequest,
  TConsultationRequestResponse,
} from '../../repositories/e2e-deal-entrypoints/v2/consultation-request';
import {
  FORM_DEFAULT_ERROR,
  TFormSubmitStatus,
  TSubmitStatus,
} from '../../containers/ConsultationRequestModalContainer';
import { EOrigin } from '../../repositories/e2e-deal-entrypoints/entities/consultation_request/ConsultationRequestV2Schema';
import { TThunkAction } from '../../types/redux';

/**
 * Отправляет форму "Хочу консультацию" на бекенд.
 */
export const sendConsultationRequest =
  (parameters: Omit<TConsultationRequestRequest, 'origin'>): TThunkAction<Promise<TFormSubmitStatus>> =>
  async (_dispatch, _getState, { httpApi, logger }) => {
    try {
      const result: FetchResponse<TConsultationRequestResponse> = await fetchConsultationRequest({
        httpApi,
        parameters: {
          ...parameters,
          origin: EOrigin.LegalCheck,
        },
      });

      if (result.statusCode !== 200) {
        throw new HttpBadStatusCodeError({
          message: `${result.response.message}`,
          domain: 'sendConsultationRequest.ts',
          statusCode: result.statusCode,
          details: {
            errors: result.response.errors as TPrimitives,
          },
        });
      }

      return { errors: null, status: TSubmitStatus.Submit };
    } catch (error) {
      const isBadStatusCodeError = HttpBadStatusCodeError.is(error);

      if (!isBadStatusCodeError) {
        logger.error(error instanceof Error ? error : new Error(String(error)), {
          message:
            'Ошибка при отправке формы "Хочу консультацию", ручка e2e-deal-entrypoints/public/v2/consultation-request/',
          degradation: 'Ошибка в форме, пользователь может повторить попытку',
          domain: 'sendConsultationRequest.ts',
          details: {
            sentFrom: parameters.sentFrom,
          },
        });
      }

      return {
        status: TSubmitStatus.Error,
        errors: {
          root: isBadStatusCodeError ? error.message : FORM_DEFAULT_ERROR,
        },
      };
    }
  };
